import arrow from "../../Images/Components/DDarrow.png";
import { useState, useEffect, useRef } from "react";
import "./Checklist.css";

export interface CheckboxOption {
  label: string;
  value: string;
}

interface CheckboxListProps {
  options: CheckboxOption[];
  selectedValues: string[];
  onChange: (selected: string[]) => void;
  // onFormChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  label?: string;
  defaultDropdownLabel?: string;
  required?: boolean;
  error?: string;
  className?: string;
}

const CheckboxList: React.FC<CheckboxListProps> = ({
  options,
  selectedValues,
  onChange,
  label,
  defaultDropdownLabel,
  required,
  error,
  className = "formInput",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleList = () => {
    setIsExpanded((prev) => !prev);
  };

  const handleToggle = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string,
  ) => {
    const isSelected = selectedValues.includes(value);

    // Handle "All"
    if (value === "") {
      onChange([]); // ALL = empty array
      return;
    }

    const updatedSelection = isSelected
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value];

    onChange(updatedSelection);
    // onFormChange(event);
  };

  const wrapperRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="checkbox-ctrl-list inputContainer">
      {label && (
        <p className="inputLabel chckbx-input-label">
          {label} {required && <span className="required">*</span>}
        </p>
      )}

      <div className={className} ref={wrapperRef}>
        <div className="checklist-ctrl-dd" onClick={toggleList}>
          <p>{defaultDropdownLabel}</p>
          <div className="selectArrow" aria-hidden="true">
            <img className="arrow" src={arrow} />
          </div>
        </div>

        {/* <button onClick={toggleList}>
                    {isExpanded ? "Collapse List" : "Expand List"}
                </button> */}
        {isExpanded && (
          <div className="checkbox-dropdown">
            {options.map((option) => {
              const isAll = option.value === "";

              return (
                <label key={option.value} className="checkbox-ctrl-item">
                  <input
                    className="checkbox-ctrl"
                    type="checkbox"
                    checked={
                      isAll
                        ? selectedValues.length === 0
                        : selectedValues.includes(option.value)
                    }
                    onChange={(e) => handleToggle(e, option.value)}
                    name={option.value}
                  />
                  <span className="checkbox-label">{option.label}</span>
                </label>
              );
            })}
          </div>
        )}
      </div>

      {error && <p className="inputError">{error}</p>}
    </div>
  );
};

export default CheckboxList;
